import {
  IDocsItems,
  IEvidenceItems,
} from 'services/NGT/DjurServices'
import { IDetailsDjur } from '../DJURService'

export type ITables = 'dadosBloqueio' | 'documentos' | 'historicoReclamante' | 'anexarEvidencias' | 'documentosParaDjur'
export type ITabTypes = 'consult' | 'reanalize' | 'addNew'
export type IForm = {
  cpfReclamante?: string
  nuProcesso?: string
  dtInicioReclamacao?: string
  dtFimReclamacao?: string
  cdContrato?: string
}

export type Action = {
  type: 'handleChangeDjurTarget',
  payload: IDetailsDjur
} | {
  type: 'handleChangeSelectedDocuments',
  payload: IDocsItems[],
} | {
  type: 'handleRefreshHistoryAndBlockData',
} | {
  type: 'handleChangeTabType',
  payload: {
    tabType: ITabTypes
  }
} | {
  type: 'handleRefreshTable',
  payload: {
    tablesForRefresh: ITables[]
  }
} | {
  type: 'handleChangeContract',
  payload: {
    cdContrato: string
    idContrato: number
  }
} | {
  type: 'handleChangeFormValue',
  payload: {
    value: string
    field: keyof IForm
  }
} | {
  type: 'handleChangeEvidencias',
  payload: IEvidenceItems[],
} | {
  type: 'handleChangeDocumentosParaDjur',
  payload: IDocsItems[]
} | {
  type: 'clearForm',
}

export type State = {
  form: IForm
  djurTarget: IDetailsDjur | null
  selectedDocuments: IDocsItems[] | null
  refreshHistoryAndDataBlock: boolean | null
  currentTabType: ITabTypes
  isConsult: boolean
  isReanalize: boolean
  isAddNew: boolean
  contract: {
    cdContrato: string
    idContrato: number
  }

  refreshHistoricoReclamante: boolean
  refreshDadosBloqueio: boolean
  refreshDocumentos: boolean
  refreshDocumentosParadjur: boolean
  refreshAnexarEvidencias: boolean
  evidences: IEvidenceItems[]
  documentosParaDjur: IDocsItems[]
}

export const INITIAL_STATE: State = {
  form: {
    cpfReclamante: '',
    nuProcesso: '',
    dtInicioReclamacao: '',
    dtFimReclamacao: '',
    cdContrato: '',
  },
  contract: {
    cdContrato: '',
    idContrato: 0,
  },
  isConsult: false,
  isReanalize: false,
  isAddNew: true,
  currentTabType: 'addNew',
  djurTarget: null,
  selectedDocuments: null,
  refreshHistoryAndDataBlock: null,

  refreshHistoricoReclamante: null,
  refreshDadosBloqueio: null,
  refreshDocumentos: null,
  refreshDocumentosParadjur: null,
  refreshAnexarEvidencias: null,
  evidences: [],
  documentosParaDjur: [],
}

export const DjurServiceReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'clearForm': {
      return {
        ...state,
        form: null,
      }
    }
    case 'handleChangeDocumentosParaDjur': {
      return {
        ...state,
        documentosParaDjur: action.payload
      }
    }
    case 'handleChangeEvidencias': {
      return {
        ...state,
        evidences: action.payload,
      }
    }
    case 'handleChangeFormValue': {
      return {
        ...state,
        form: {
          [action?.payload?.field]: action?.payload?.value,
        }
      }
    }
    case 'handleChangeContract': {
      return {
        ...state,
        contract: action.payload,
      }
    }
    case 'handleRefreshTable': {
      const enumTables = {
        dadosBloqueio: 'refreshDadosBloqueio',
        documentos: 'refreshDocumentos',
        historicoReclamante: 'refreshHistoricoReclamante',
        anexarEvidencias: 'refreshAnexarEvidencias',
        documentosParaDjur: 'refreshDocumentosParadjur',
      }
      const tablesRefreshStates = {}

      action.payload.tablesForRefresh.forEach(table => {
        tablesRefreshStates[enumTables[table]] = !state[enumTables[table]]
      })

      return {
        ...state,
        ...tablesRefreshStates,
      }
    }
    case 'handleChangeDjurTarget': {
      return {
        ...state,
        djurTarget: action.payload
      }
    }
    case 'handleChangeSelectedDocuments': {
      return {
        ...state,
        selectedDocuments: action.payload
      }
    }
    case 'handleRefreshHistoryAndBlockData': {
      return {
        ...state,
        refreshHistoryAndDataBlock: !state.refreshHistoryAndDataBlock
      }
    }
    case 'handleChangeTabType': {
      return {
        ...state,
        currentTabType: action.payload.tabType,
        isConsult: action.payload.tabType === 'consult',
        isReanalize: action.payload.tabType === 'reanalize',
        isAddNew: action.payload.tabType === 'addNew',
      }
    }
    default: {
      throw new Error('Unhandled action type')
    }
  }
}
